import { connectClearRefinements } from "instantsearch.js/es/connectors";
import { provide, ref } from "vue";
export const useAisClearRefinements = (widgetParams, id = "") => {
  const stateRef = ref();
  const renderClearRefinements = (renderState, isFirstRender) => {
    stateRef.value = renderState;
    if (isFirstRender) {
      provide(`clearRefinements-${id}`, stateRef);
    }
    return () => null;
  };
  const customClearRefinements = connectClearRefinements(
    renderClearRefinements
  );
  return {
    ...customClearRefinements(widgetParams),
    $$widgetParams: widgetParams,
    $$widgetId: id
  };
};
